import { quotesService } from '@/services/quotes';
import type { SendProposalEmailPayload } from '@/services/quotes/types';
import { useMutation } from '@tanstack/react-query';

export function useSendProposalEmail() {
  return useMutation<void, Error, SendProposalEmailPayload>({
    mutationKey: ['quotes', 'send-email'],
    mutationFn: async payload => {
      const response = await quotesService.sendProposalEmail(payload);

      if (!response.success) {
        throw new Error(response.error || 'Erro ao enviar e-mail');
      }
    },
  });
}
